import React from "react";

import { TypeInsignia } from "@at/design-system-foundation";
import { Accordion, Banner } from "@at/design-system-patterns";
import { getChannelSingular } from "@at/formatter-utils";
import { Channel } from "@at/sauron-platform-core";

import * as Styled from "./charging.styles";
import {
  DomesticThreePinPlug,
  HomeChargingPoint,
} from "./home-charging-point-expander-info";
import { useChannel } from "../../../utils/hooks/use-channel";
import { useTracking } from "../../../utils/tracking/use-tracking";

export const HomeChargingInfo = () => {
  const channel = useChannel();
  const { trackAccordionEvent } = useTracking();
  const channelSingular = getChannelSingular(channel);
  const channelCopy = channel === Channel.cars ? "car" : "vehicle";
  const homeChargingPointInfo = HomeChargingPoint(channelCopy, channelSingular);
  const domesticThreePinPlugInfo = DomesticThreePinPlug(
    channel,
    channelSingular,
  );

  return (
    <>
      <Styled.ModalBodyStyled>
        <TypeInsignia as="h2" weight="400">
          Home charging explained
        </TypeInsignia>
        <p>
          There are two main options most people use to charge an electric
          vehicle at home. The most recommended and most common option is to
          have a home charge point installed. You can also plug an electric
          vehicle directly into a three-pin plug, however you can expect a much
          longer charge time charging in this way.
        </p>

        <Banner variation={"info"} type={"in-panel"}>
          Both home charging options will require you to have access to
          off-street parking in the majority of situations.
        </Banner>

        <Accordion
          items={homeChargingPointInfo}
          trackingCallback={(rowProps) => {
            trackAccordionEvent({ row: rowProps, data: homeChargingPointInfo });
          }}
        />
        <Accordion
          items={domesticThreePinPlugInfo}
          trackingCallback={(rowProps) => {
            trackAccordionEvent({
              row: rowProps,
              data: domesticThreePinPlugInfo,
            });
          }}
        />
      </Styled.ModalBodyStyled>
    </>
  );
};
